/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectionDto } from '../models/ConnectionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteParticipantConnectionControllerService {

    /**
     * Connects/Disconnects an already registered domain to a participant
     * @param name
     * @param domainAlias
     * @param connect true to connect, false to disconnect
     * @returns void
     * @throws ApiError
     */
    public static updateRemoteParticipantConnection(
        name: string,
        domainAlias: string,
        connect: boolean,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/remote-participants/{name}/connections/{domainAlias}',
            path: {
                'name': name,
                'domainAlias': domainAlias,
            },
            query: {
                'connect': connect,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Lists all configured domain connections of a participant
     * @param name
     * @returns ConnectionDto OK
     * @throws ApiError
     */
    public static listRemoteParticipantConnections(
        name: string,
    ): CancelablePromise<Array<ConnectionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants/{name}/connections',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Configures, registers and connects a domain to a participant
     * @param name
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createRemoteParticipantConnection(
        name: string,
        requestBody: ConnectionDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-participants/{name}/connections',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

}
